import { createUseTranslation } from "core/session/translation";

export const useNoAppsAvailablePageTranslation = createUseTranslation({
  en: {
    noAppsAvailableText: "No Apps Available",
  },
});
